import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Thank_You from "./components/thank_you/Thank_You";

function App() {

  const location = useLocation();
  const hideHeaderFooter = [
    "/thank-you",
  ].includes(location.pathname);

  return (
    <>
      {/* <ScrollToTop /> */}
      {!hideHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<Thank_You />} />
      </Routes>
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

export default App;
